<template>
  <b-overlay
    :show="busy"
    spinner-type="grow"
    spinner-variant="primary"
    rounded="sm"
  >
    <b-card class="border-none py-0 mb-0 px-1">
      <b-card-body class="py-0 px-0">
        <b-tabs class="gridtabs">
          <b-tab active>
            <template #title>
              <i :class="options.icon" class="text-primary mr-1"></i>
              {{ item.email }}
              <span class="text-warning"
                >&lt;{{ selection.length == 0 ? "new" : "edit" }}&gt;</span
              >
            </template>
            <p class="py-3 px-0">
              <b-row>
                <b-col cols="12" sm="6" md="4" xl="3">
                  <b-form-group
                    label="Email"
                    label-for="email"
                    label-cols="12"
                    label-size="sm"
                  >
                    <b-input-group>
                      <b-form-input
                        id="email"
                        type="email"
                        size="sm"
                        v-model="item.email"
                        placeholder="Enter email"
                        :debounce="options.debounce"
                      ></b-form-input>
                      <b-form-invalid-feedback
                        >Email: Required</b-form-invalid-feedback
                      >
                      <b-input-group-append>
                        <b-button
                          size="sm"
                          variant="outline-secondary"
                          disabled
                          @click="item.email = ''"
                        >
                          <i class="fa fa-remove"></i>
                        </b-button>
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                </b-col>
                <b-col cols="12" sm="6" md="4" xl="3">
                  <b-form-group
                    label="Mobile for 2FA/OTP"
                    label-for="mobile"
                    label-cols="12"
                    label-size="sm"
                  >
                    <b-input-group>
                      <b-2fa
                        label=" Cell Phone"
                        v-model="item.mobile"
                        size="sm"
                        :darkmode="$store.state.darkMode"
                        placeholder="Cell Phone"
                        :debounce="options.debounce"
                        @keyup.native="isChanged()"
                        class="w-100pct"
                      />
                    </b-input-group>
                  </b-form-group>
                </b-col>
                <b-col cols="12" sm="6" md="4" xl="3">
                  <b-form-group
                    label="Role"
                    label-for="role"
                    label-cols="12"
                    label-size="sm"
                  >
                    <treeselect
                      instanceId="role"
                      type="number"
                      v-model="item.rolename"
                      :clearable="false"
                      :options="options_roles"
                      :multiple="false"
                    ></treeselect>
                  </b-form-group>
                </b-col>

                <b-col cols="12" sm="6" md="4" xl="3">
                  <b-form-group
                    label="Enabled"
                    label-for="status"
                    label-cols="12"
                  >
                    <b-form-radio-group
                      id="status"
                      v-model="item.status"
                      :options="[
                        { text: 'Yes', value: 0 },
                        { text: 'No', value: 9 },
                      ]"
                      buttons
                      button-variant="outline-success"
                      size="sm"
                      name="radio-btn-outline"
                    ></b-form-radio-group>
                  </b-form-group>
                </b-col>

                <!--    <b-col cols="12" sm="6">
            <b-form-group
              label="Status"
              label-for="status"
              label-cols="12"
              label-size="sm"
            >
              <b-form-radio-group
                v-model="item.status"
                :options="[
                  { text: 'ENABLED', value: '0' },
                  { text: 'INVITED', value: '1' },
                  { text: 'SIGNUP', value: '2' },
                  { text: 'FORGOT', value: '3' },
                  { text: 'DISABLED', value: '9' },
                ]"
                buttons
                button-variant="outline-success"
                size="sm"
                name="radio-btn-outline"
                :debounce="options.debounce"
              ></b-form-radio-group>
            </b-form-group>
          </b-col> -->
              </b-row>
              <b-row>
                <b-col cols="12" sm="6" md="4" xl="3">
                  <b-form-group
                    label="Firstname"
                    label-for="firstname"
                    label-cols="12"
                    label-size="sm"
                  >
                    <b-input-group>
                      <b-form-input
                        id="firstname"
                        type="text"
                        size="sm"
                        v-model="item.firstname"
                        :debounce="options.debounce"
                        placeholder="Enter firstname"
                        @keyup.native="isChanged()"
                      ></b-form-input>

                      <b-form-invalid-feedback
                        >Firstname: Required</b-form-invalid-feedback
                      >
                      <b-input-group-append>
                        <b-button
                          size="sm"
                          variant="outline-secondary"
                          :disabled="!item.firstname"
                          @click="item.firstname = ''"
                        >
                          <i class="fa fa-remove"></i>
                        </b-button>
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                </b-col>
                <b-col cols="12" sm="6" md="4" xl="3">
                  <b-form-group
                    label="Lastname"
                    label-for="lastname"
                    label-cols="12"
                    label-size="sm"
                  >
                    <b-input-group>
                      <b-form-input
                        id="lastname"
                        type="text"
                        size="sm"
                        v-model="item.lastname"
                        placeholder="Enter lastname"
                        :debounce="options.debounce"
                        @keyup.native="isChanged()"
                      ></b-form-input>

                      <b-form-invalid-feedback
                        >Lastname: Required</b-form-invalid-feedback
                      >
                      <b-input-group-append>
                        <b-button
                          size="sm"
                          variant="outline-secondary"
                          :disabled="!item.lastname"
                          @click="item.lastname = ''"
                        >
                          <i class="fa fa-remove"></i>
                        </b-button>
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                </b-col>
                <b-col cols="12" sm="6" md="4" xl="3">
                  <b-form-group
                    label="Title"
                    label-for="title"
                    label-cols="12"
                    label-size="sm"
                  >
                    <treeselect
                      v-model="item.title"
                      :clearable="true"
                      :options="options_title"
                      :disabled="false"
                    ></treeselect>
                    <b-form-invalid-feedback
                      >Title: Required</b-form-invalid-feedback
                    >
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="12">
                  <b-form-group
                    label="Comments"
                    label-for="comments"
                    label-cols="12"
                  >
                    <b-form-textarea
                      id="comments"
                      v-model="item.comments"
                      placeholder="Comments"
                      rows="3"
                      max-rows="8"
                      class="smalltextarea"
                    ></b-form-textarea>
                  </b-form-group> </b-col
              ></b-row>
            </p>
          </b-tab>

          <b-tab>
            <template #title>
              <i class="fa fa-industry text-primary mr-1"></i>
              Company</template
            >
            <p class="py-3 px-0">
              <b-row>
                <b-col cols="12" sm="6" md="4" xl="3">
                  <b-form-group
                    label="Company"
                    label-for="companyname"
                    label-cols="12"
                    label-size="sm"
                  >
                    <b-input-group>
                      <b-form-input
                        id="company"
                        type="text"
                        size="sm"
                        v-model="item.company"
                        placeholder="Enter company name"
                        @keyup.native="isChanged()"
                      ></b-form-input>
                      <b-input-group-append>
                        <b-button
                          size="sm"
                          variant="outline-secondary"
                          :disabled="!item.company"
                          @click="item.company = ''"
                        >
                          <i class="fa fa-remove"></i>
                        </b-button>
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                </b-col>

                <b-col cols="12" sm="6" md="4" xl="3">
                  <b-form-group
                    label="Phone"
                    label-for="telephone"
                    label-cols="12"
                    label-size="sm"
                  >
                    <b-2fa
                      label="Phone"
                      size="sm"
                      v-model="item.companytelephone"
                      :darkmode="$store.state.darkMode"
                      placeholder="Telephone"
                      @keyup.native="isChanged()"
                    />
                  </b-form-group>
                </b-col>
                <b-col cols="12" sm="6" md="4" xl="3">
                  <b-form-group
                    label="Extension"
                    label-for="extension"
                    label-cols="12"
                    label-size="sm"
                  >
                    <b-input-group>
                      <b-form-input
                        id="extension"
                        type="text"
                        size="sm"
                        v-model="item.extension"
                        placeholder="Enter extension"
                        @keyup.native="isChanged()"
                      ></b-form-input>
                      <b-input-group-append>
                        <b-button
                          size="sm"
                          variant="outline-secondary"
                          :disabled="!item.extension"
                          @click="item.extension = ''"
                        >
                          <i class="fa fa-remove"></i>
                        </b-button>
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                </b-col>
                <b-col cols="12" sm="6" md="4" xl="3">
                  <b-form-group
                    label="Department"
                    label-for="department"
                    label-cols="12"
                    label-size="sm"
                  >
                    <b-input-group>
                      <b-form-input
                        id="department"
                        type="text"
                        size="sm"
                        v-model="item.department"
                        placeholder="Enter department"
                        @keyup.native="isChanged()"
                      ></b-form-input>
                      <b-input-group-append>
                        <b-button
                          size="sm"
                          variant="outline-secondary"
                          :disabled="!item.department"
                          @click="item.department = ''"
                        >
                          <i class="fa fa-remove"></i>
                        </b-button>
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                </b-col>
                <b-col cols="12" sm="6" md="4" xl="3">
                  <b-form-group
                    label="Job Title"
                    label-for="jobtitle"
                    label-cols="12"
                    label-size="sm"
                  >
                    <b-input-group>
                      <b-form-input
                        id="jobtitle"
                        type="text"
                        size="sm"
                        v-model="item.jobtitle"
                        placeholder="Enter jobtitle"
                        @keyup.native="isChanged()"
                      ></b-form-input>
                      <b-input-group-append>
                        <b-button
                          size="sm"
                          variant="outline-secondary"
                          :disabled="!item.jobtitle"
                          @click="item.jobtitle = ''"
                        >
                          <i class="fa fa-remove"></i>
                        </b-button>
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                </b-col>
                <b-col cols="12" sm="6" md="4" xl="3">
                  <b-form-group
                    label-cols="12"
                    label="Client SL A/C"
                    label-size="sm"
                  >
                    <treeselect
                      placeholder="Select slac..."
                      searchPromptText="Type at least 3 chars..."
                      v-model="item.slac"
                      :clearable="true"
                      :async="true"
                      :load-options="treeselect_loadSLAC"
                      :show-count="true"
                      :flatten-search-results="true"
                      :disable-branch-nodes="true"
                      :matchKeys="['id']"
                      search-nested
                      :disabled="readonly"
                      multiple="true"
                    >
                      <div slot="value-label" slot-scope="{ node }">
                        {{ node.raw.id }}
                      </div>
                    </treeselect>
                  </b-form-group>
                </b-col>
                <b-col cols="12" sm="6" md="4" xl="3">
                  <b-form-group
                    label="Agent, GDS ID"
                    label-for="initials"
                    label-cols="12"
                    label-size="sm"
                  >
                    <b-input-group>
                      <b-form-input
                        id="initials"
                        type="text"
                        size="sm"
                        v-model="item.initials"
                        placeholder="Enter Initials"
                        @keyup.native="isChanged()"
                      ></b-form-input>
                      <b-input-group-append>
                        <b-button
                          size="sm"
                          variant="outline-secondary"
                          :disabled="!item.initials"
                          @click="item.initials = ''"
                        >
                          <i class="fa fa-remove"></i>
                        </b-button>
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                </b-col>
              </b-row>
            </p>
          </b-tab>

          <b-tab>
            <template #title>
              <i class="fa fa-unlock text-primary mr-1"></i>Permissions
            </template>
            <p class="py-3 px-0">
              <!-- <b-row>
                <b-col cols="12" sm="12" md="12" xl="12">
                  <b-form-group
                    label="UI Experience (Most suitable)"
                    label-for="experience"
                    label-cols="12"
                    label-size="sm"
                  >
                    <treeselect
                      v-model="experience"
                      :options="options_experience"
                    ></treeselect>
                  </b-form-group>
                </b-col>
              </b-row> -->
              <b-row>
                <b-col cols="12" sm="12" md="12" xl="12">
                  <b-form-group
                    label="Permissions"
                    label-for="permissions"
                    label-cols="12"
                    label-size="sm"
                  >
                    <treeselect
                      v-model="item.permissions"
                      :multiple="true"
                      :maxHeight="600"
                      :show-count="true"
                      :value-consists-of="'LEAF_PRIORITY'"
                      autoSelectDescendants
                      autoDeselectDescendants
                      :options="options_permissions"
                    ></treeselect>
                  </b-form-group>
                </b-col>
              </b-row>
            </p>
          </b-tab>

          <b-tab>
            <template #title>
              <i class="fa fa-history text-primary mr-1"></i>Audit
            </template>
            <p class="py-3 px-0">
              <b-row v-if="idselected">
                <b-col cols="12" sm="6" md="4" xl="3">
                  <b-form-group
                    label="Created At"
                    label-for="created_at"
                    label-cols="12"
                  >
                    <b-input-group>
                      <b-input-group-prepend>
                        <b-form-datepicker
                          size="sm"
                          v-model="item.created_at"
                          button-only
                          label-help=""
                          locale="en-GB"
                          :disabled="true"
                        ></b-form-datepicker>
                      </b-input-group-prepend>
                      <b-form-input
                        size="sm"
                        id="date"
                        v-model="item.created_at"
                        type="text"
                        placeholder="YYYY-MM-DD"
                        autocomplete="off"
                        :disabled="true"
                      ></b-form-input>
                      <b-input-group-append>
                        <b-button
                          size="sm"
                          variant="outline-secondary"
                          @click="item.created_at = null"
                          :disabled="true"
                        >
                          <i class="fa fa-remove"></i>
                        </b-button>
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                </b-col>

                <b-col cols="12" sm="6" md="4" xl="3">
                  <b-form-group
                    label="Created By"
                    label-for="created_by"
                    label-cols="12"
                  >
                    <b-input-group>
                      <b-form-input
                        type="text"
                        v-model="item.created_by"
                        placeholder=""
                        size="sm"
                        :disabled="true"
                      ></b-form-input>
                      <b-input-group-append>
                        <b-button
                          size="sm"
                          variant="outline-secondary"
                          @click="item.created_by = ''"
                          :disabled="true"
                        >
                          <i class="fa fa-remove"></i>
                        </b-button>
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                </b-col>

                <b-col cols="12" sm="6" md="4" xl="3">
                  <b-form-group
                    label="Updated At"
                    label-for="updated_at"
                    label-cols="12"
                  >
                    <b-input-group>
                      <b-input-group-prepend>
                        <b-form-datepicker
                          size="sm"
                          v-model="item.updated_at"
                          button-only
                          label-help=""
                          locale="en-GB"
                          :disabled="true"
                        ></b-form-datepicker>
                      </b-input-group-prepend>
                      <b-form-input
                        size="sm"
                        id="date"
                        v-model="item.updated_at"
                        type="text"
                        placeholder="YYYY-MM-DD"
                        autocomplete="off"
                        :disabled="true"
                      ></b-form-input>
                      <b-input-group-append>
                        <b-button
                          size="sm"
                          variant="outline-secondary"
                          @click="item.updated_at = null"
                          :disabled="true"
                        >
                          <i class="fa fa-remove"></i>
                        </b-button>
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                </b-col>

                <b-col cols="12" sm="6" md="4" xl="3">
                  <b-form-group
                    label="Updated By"
                    label-for="updated_by"
                    label-cols="12"
                  >
                    <b-input-group>
                      <b-form-input
                        type="text"
                        v-model="item.updated_by"
                        placeholder=""
                        size="sm"
                        :disabled="true"
                      ></b-form-input>
                      <b-input-group-append>
                        <b-button
                          size="sm"
                          variant="outline-secondary"
                          @click="item.updated_by = ''"
                          :disabled="true"
                        >
                          <i class="fa fa-remove"></i>
                        </b-button>
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                </b-col>
              </b-row>
            </p>
          </b-tab>
        </b-tabs>
      </b-card-body>
      <b-card-footer class="mt-2">
        <b-row>
          <b-col cols="auto" class="text-left">
            <div v-if="busy">
              <i class="fa fa-spinner fa-spin text-primary"></i>
            </div>
            <div v-else>
              <span v-html="message"></span>
            </div>
          </b-col>
          <b-col class="text-right">
            <b-button
              squared
              size="sm"
              variant="secondary"
              class="mr-1"
              @click="discard"
            >
              <i class="fa fa-chevron-left pr-1"></i>
              Back
            </b-button>
            <b-button squared size="sm" variant="primary" @click="saveit">
              <i class="fa fa-check"></i>
              Save It
            </b-button>
          </b-col>
        </b-row>
      </b-card-footer>
    </b-card>
  </b-overlay>
</template>

<script>
import gql from "graphql-tag";

export default {
  name: "UsersEdit",
  data() {
    return {
      busy: false,
      message: "",
      readonly: false,
      item: {
        role: {
          name: "user",
        },
        id: 0,
        status: 0,
        email: null,
        company: "Travel Places",
        department: "EVENTS",
        slac: [],
      },
      options_roles: [],
      experience: null,
      options_experience: [
        { id: "permissions_accounts", label: "Accounts Experience" },
        { id: "permissions_all", label: "All Experience" },
        { id: "permissions_api", label: "API Experience" },
        { id: "permissions_basic", label: "Basic Experience" },
        { id: "permissions_clients", label: "Clients Experience" },
        { id: "permissions_development", label: "Development Experience" },
        { id: "permissions_events", label: "Events Experience" },
        { id: "permissions_f1", label: "F1 Experience" },
        { id: "permissions_prosports", label: "Pro Sports Experience" },
        { id: "permissions_neptune", label: "Neptune Experience" },
      ],
      options_permissions: [],
      options_title: [
        { id: "Mr", label: "Mr" },
        { id: "Mrs", label: "Mrs" },
        { id: "Ms", label: "Ms" },
        { id: "Miss", label: "Miss" },
        { id: "Dr", label: "Dr" },
      ],
      options: {
        title: "Users",
        icon: "fa fa-user-circle",
      },
    };
  },
  watch: {
    // async experience() {
    //   let data = await this.getsystemsetting(this.experience);
    //   if (data) {
    //     data = JSON.parse(data);
    //     if (Array.isArray(data)) {
    //       if (data.length > 0) {
    //         this.item.permissions = data;
    //       }
    //     }
    //   }
    // },
  },
  methods: {
    async loadDDL() {
      console.log("loadDDL");
      try {
        const response = await this.$apollo.query({
          query: gql`
            query usersroles {
              usersroles {
                id: name
                label: name
              }
            }
          `,
        });
        this.options_roles = response.data.usersroles;
        for (var i = 0; i < this.options_roles.length; i++) {
          this.options_roles[i].id = this.options_roles[i].id.toLowerCase();
          this.options_roles[i].label =
            this.options_roles[i].label.toLowerCase();
        }
      } catch (error) {
        console.log(error);
      }
      let data = await this.$helpers.getsystemsetting("permissions_ux");
      if (data) {
        this.options_permissions = JSON.parse(data);
      }
    },
    async load() {
      this.busy = true;

      let variables = {
        id: this.idselected,
        dateformat: this.dateformat,
      };
      console.log("variables", variables);
      try {
        const response = await this.$apollo.query({
          query: gql`
            query users_mssql($id: String) {
              users_mssql(id: $id) {
                id
                rolename
                email
                title
                firstname
                lastname
                mobile
                department
                company
                companytelephone
                extension
                jobtitle
                status
                slac
                initials
                comments
                permissions
                created_at
                updated_at
              }
            }
          `,
          variables,
        });

        if (response.data.users_mssql.length > 0) {
          this.item = response.data.users_mssql[0];

          this.item.slac = this.item.slac ? this.item.slac.split(",") : [];

          if (this.item.permissions) {
            // this.item.permissions = this.upgrade(this.item.permissions);

            this.item.permissions = JSON.parse(this.item.permissions);
          }
        }
      } catch (error) {
        console.log(error);
      }

      this.busy = false;
    },

    upgrade(permissions) {
      let newpermissions = [];

      // MAP OLD TO NEW
      if (permissions.includes("/dashboard")) {
        newpermissions.push("navigation.dashboard");
      }
      if (permissions.includes("/notifications")) {
        newpermissions.push("navigation.notifications");
      }
      if (permissions.includes("/documents")) {
        newpermissions.push("navigation.documents");
      }
      if (permissions.includes("/applications/accounts")) {
        newpermissions.push("navigation.accounts");
      }
      if (permissions.includes("/applications/orders")) {
        newpermissions.push("navigation.orders");
      }
      if (permissions.includes("/applications/flights")) {
        newpermissions.push("navigation.flights");
      }
      if (permissions.includes("/applications/hotels")) {
        newpermissions.push("navigation.hotels");
      }
      if (permissions.includes("/applications/cars")) {
        newpermissions.push("navigation.cars");
      }
      if (permissions.includes("/reports")) {
        newpermissions.push("navigation.reports");
      }
      if (permissions.includes("/systems")) {
        newpermissions.push("navigation.systems");
      }
      if (permissions.includes("/partners")) {
        newpermissions.push("navigation.ourpartners");
      }
      newpermissions.push("navigation.help");

      // NOW THE OBJECTS
      if (permissions.includes("/notifications")) {
        newpermissions.push("notifications.view");
      }
      if (permissions.includes("/documents")) {
        newpermissions.push("documents.view");
      }
      if (permissions.includes("/dashboard/bookingforms")) {
        newpermissions.push("bookingforms.view");
        newpermissions.push("bookingforms.save");
        newpermissions.push("bookingforms.delete");
      }
      if (permissions.includes("/dashboard/draftinvoices")) {
        newpermissions.push("draftinvoices.view");
        newpermissions.push("draftinvoices.save");
        newpermissions.push("draftinvoices.delete");
      }
      if (permissions.includes("/dashboard/sltransactions")) {
        newpermissions.push("salesledger.view");
      }
      if (permissions.includes("/dashboard/clients")) {
        newpermissions.push("clients.view");
      }
      if (permissions.includes("/dashboard/events")) {
        newpermissions.push("events.view");
      }
      if (permissions.includes("/dashboard/suppliers")) {
        newpermissions.push("suppliers.view");
      }

      // ACCOUNTS
      // SL
      if (permissions.includes("/accounts/clients,sl/sltransactions")) {
        newpermissions.push("salesledger.view");
      }
      if (permissions.includes("/accounts/clients,sl/slpayments")) {
        newpermissions.push("salesledger.payments");
      }
      if (permissions.includes("/accounts/clients,sl/slstatements")) {
        newpermissions.push("salesledger.statements");
      }

      // BL
      if (permissions.includes("/accounts/suppliers,bl/bltransactions")) {
        newpermissions.push("boughtledger.view");
      }
      if (permissions.includes("bltransactions.save")) {
        newpermissions.push("boughtledger.save");
      }
      if (permissions.includes("bltransactions.delete")) {
        newpermissions.push("boughtledger.delete");
      }
      if (permissions.includes("bltransactions.admin")) {
        newpermissions.push("boughtledger.admin");
      }
      if (permissions.includes("bltransactions.saracs")) {
        newpermissions.push("boughtledger.saracs");
      }
      if (permissions.includes("/accounts/suppliers,bl/blpayments")) {
        newpermissions.push("boughtledger.payments");
      }

      // NL
      if (permissions.includes("/accounts/suppliers,nl/nltransactions")) {
        newpermissions.push("nominalledger.view");
      }
      if (permissions.includes("/accounts/balance,nl/nltrialbalance")) {
        newpermissions.push("nominalledger.trialbalance");
      }
      if (permissions.includes("/accounts/balance,nl/nlviewnominals")) {
        newpermissions.push("nominalledger.view");
      }

      if (permissions.includes("/accounts/setup/accountingcodes")) {
        newpermissions.push("setup.accountingcodes");
      }
      if (permissions.includes("/accounts/setup/bookingpaymentmethods")) {
        newpermissions.push("setup.bookingpaymentcodes");
      }
      if (permissions.includes("/accounts/setup/currencies")) {
        newpermissions.push("setup.currencycodes");
      }
      if (permissions.includes("/accounts/setup/clientaccounttypes")) {
        newpermissions.push("setup.clientaccounttypecodes");
      }
      if (permissions.includes("/accounts/setup/nlcodes")) {
        newpermissions.push("setup.nlcodes");
      }
      if (permissions.includes("/accounts/setup/suppliertypes")) {
        newpermissions.push("setup.suppliertypecodes");
      }
      if (permissions.includes("/accounts/setup/salesgroups")) {
        newpermissions.push("setup.salesgroupcodes");
      }
      if (permissions.includes("/accounts/setup/transactiontypes")) {
        newpermissions.push("setup.transactiontypecodes");
      }
      if (permissions.includes("/accounts/setup/zonecharges")) {
        newpermissions.push("setup.zonechargecodes");
      }
      if (permissions.includes("/accounts/setup/transactionfees")) {
        newpermissions.push("setup.transactionfeecodes");
      }
      // SPECIAL
      if (permissions.includes("/accounts/setup/events")) {
        newpermissions.push("events.view");
      }

      if (permissions.includes("/accounts/periodend")) {
        newpermissions.push("periodend.view");
      }

      // ORDERS
      if (permissions.includes("/orders/ordertracking")) {
        newpermissions.push("orders.view");
        newpermissions.push("orders.save");
        newpermissions.push("orders.delete");
      }
      if (permissions.includes("/orders/codes/reasoncodes")) {
        newpermissions.push("setup.orderreasoncodes");
      }

      // CARS
      if (permissions.includes("/cars/carbookings")) {
        newpermissions.push("cars.view");
      }
      if (permissions.includes("carbookings.save")) {
        newpermissions.push("cars.save");
        newpermissions.push("cars.invoice");
      }
      if (permissions.includes("carbookings.delete")) {
        newpermissions.push("cars.delete");
      }

      // FLIGHTS
      if (permissions.includes("/flights/vipasp")) {
        newpermissions.push("flights.view");
      }
      if (permissions.includes("/flights/charters")) {
        newpermissions.push("charters.view");
      }
      if (permissions.includes("pnrrepository")) {
        newpermissions.push("pnrlibrary.view");
      }
      if (permissions.includes("pnrlibrary.save")) {
        newpermissions.push("pnrlibrary.save");
      }
      if (permissions.includes("pnrlibrary.delete")) {
        newpermissions.push("pnrlibrary.delete");
      }
      if (permissions.includes("/accounts/ticketing/ticketsrepository")) {
        newpermissions.push("tickets.view");
      }
      if (permissions.includes("/flights/ticketing/ticketsvalid")) {
        newpermissions.push("tickets.validation");
      }
      if (permissions.includes("/flights/ticketing/ticketsvoid")) {
        newpermissions.push("tickets.void");
      }
      if (permissions.includes("/flights/ticketing/ticketscc")) {
        newpermissions.push("tickets.costcentre");
      }
      if (permissions.includes("/flights/setup/aircraft")) {
        newpermissions.push("setup.aircrafts");
      }
      if (permissions.includes("/flights/setup/airlines")) {
        newpermissions.push("setup.airlines");
      }
      if (permissions.includes("/flights/setup/airports")) {
        newpermissions.push("setup.airports");
      }
      if (permissions.includes("/flights/setup/standardclasses")) {
        newpermissions.push("setup.classesstandard");
      }
      if (permissions.includes("/flights/setup/exceptionsclasses")) {
        newpermissions.push("setup.classesexception");
      }
      if (permissions.includes("/flights/setup/passengers")) {
        newpermissions.push("setup.passengers");
      }

      // HOTELS
      if (permissions.includes("/hotels/hotelbookings")) {
        newpermissions.push("hotels.view");
        newpermissions.push("hotels.save");
        newpermissions.push("hotels.delete");
      }

      // /hotels/hotelroomlists

      return newpermissions;
    },
    async saveit() {
      this.busy = true;

      let variables = { rows: [this.cleanit(this.item)] };

      variables.rows[0].slac =
        variables.rows[0].slac.length > 0
          ? variables.rows[0].slac.join(",")
          : null;
      variables.rows[0].permissions = JSON.stringify(
        variables.rows[0].permissions
      );
      console.log("variables", variables);

      try {
        const response = await this.$apollo.mutate({
          mutation: gql`
            mutation users_save_mssql($rows: [User_input]) {
              users_save_mssql(rows: $rows) {
                id
              }
            }
          `,
          variables,
        });
        console.log(response);
        this.message = "<span class='text-primary'>Saved it.</span>";
      } catch (error) {
        this.message = "<span class='text-danger'>" + error.message + "</span>";
      }

      this.busy = false;
    },
  },
};
</script>

<style>
</style>